import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 23 23"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#0E58D8",
      d: "M21.058 11.008q-.318-3.966-3.099-6.746-2.78-2.78-6.746-3.1V.172q2.195.142 4.108 1.027 1.912.886 3.364 2.337 1.453 1.453 2.338 3.365.886 1.913 1.027 4.108zm-5.666 0a5.3 5.3 0 0 0-1.452-2.744 4.96 4.96 0 0 0-2.727-1.435v-.991a5.84 5.84 0 0 1 3.435 1.717 6.16 6.16 0 0 1 1.735 3.453zm4.993 11.9q-3.329 0-6.924-1.753-3.594-1.753-6.746-4.905-3.117-3.151-4.87-6.73Q.092 5.945.092 2.616q0-.637.425-1.08a1.41 1.41 0 0 1 1.062-.443h2.834q.602 0 1.044.372.443.371.62.974l.638 2.904q.106.601-.036 1.062-.141.46-.496.744l-3.01 2.727q.92 1.665 2.001 3.064t2.284 2.638q1.275 1.275 2.763 2.373t3.294 2.09l2.94-3.01q.354-.39.76-.497.408-.105.94-.035l2.407.496q.602.141.974.602t.372 1.062v2.763q0 .638-.442 1.062a1.5 1.5 0 0 1-1.08.425"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "ring"}) } }